import { requireAuth } from '@/router/helpers';

/**
 * FE routes
 */
const FeRoutes = [
  // news front page
  {
    path: '/news',
    name: 'NewsIndexPage',
    component: () => import('@/views/news'),
    beforeEnter: requireAuth,
  },

  {
    path: '/news/article/:id',
    name: 'NewsRead',
    components: {
      default: () => import('@/views/news'),
      panel: () => import('@/views/news/Article'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: false, openPanel: true, whiteBg: true },
  },

  /**
   * Admin routes
   */
];

const AdminRoutes = [
  {
    path: '/admin/news',
    name: 'AdminNewsIndexPage',
    component: () => import('@/views/news/admin/Index'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: '/admin/news/create',
    name: 'AdminNewsCreate',
    component: () => import('@/views/news/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: '/admin/news/:tabFilter',
    name: 'AdminNewsIndexPageFilter',
    component: () => import('@/views/news/admin/Index'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: '/admin/news/:id/edit',
    name: 'AdminNewsEdit',
    component: () => import('@/views/news/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
];

export default [...FeRoutes,...AdminRoutes];
